import { render, staticRenderFns } from "./UsrClmLim.vue?vue&type=template&id=bc3d72ec&"
import script from "./UsrClmLim.vue?vue&type=script&lang=js&"
export * from "./UsrClmLim.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports